import {updateVisitaOfflineOperationStatus} from './visitaOfflineOperationQueue.js';
import {getOfflineStorageDriver} from './offlineStorageAdapter.js';

export async function sendClaimedVisitaStart({claimed, ownerId, empresaId, send, isCurrent=()=>true}) {
    if (claimed?.type!=='iniciar_visita'||!claimed.claimToken||claimed.ownerId!==ownerId) throw Error('El inicio requiere una concesión propia.');
    const update=async(status,lastError,extra={})=>await updateVisitaOfflineOperationStatus(claimed.id,
        {status,lastError,ownerId,claimToken:claimed.claimToken,...extra})?{status,message:lastError,...extra}:{status:'stale'};
    const payload=claimed.payload,uuid=claimed.operation_uuid;
    if(payload?.start_contract!==1||Number(payload.owner_empresa_id)!==Number(empresaId)||!uuid)
        return update('conflict','La identidad del inicio requiere revisión.');
    if(!isCurrent())return {status:'stale'};
    let response;
    try {response=await send(payload,{idempotencyKey:`operation:${uuid}`,client_uuid:uuid});}
    catch(error){
        if(!isCurrent())return {status:'stale'};
        const status=error?.response?.status;
        if(status===401)return update('pending','Sesión vencida. Inicio conservado.',{unauthorized:true});
        if(!status||[408,423,429].includes(status)||status>=500||(status===409&&error.response.data?.operation_status==='in_progress'))
            return update('pending','Sin confirmación del inicio. Se reintentará la misma intención.',{incrementRetry:true});
        return update('conflict','El inicio requiere revisión en el servidor. Se conserva la intención original.');
    }
    if(!isCurrent())return {status:'stale'};
    const data=response?.data||response||{};
    if(response?._httpStatus!==200||data.success!==true||data.applied_operation_uuid!==uuid||data.start_effect!=='started'
        ||Number(data.visita_id)!==claimed.visitaId||Number(data.empresa_id)!==Number(empresaId)||Number(data.user_id)!==claimed.userId
        ||data.client_started_at!==payload.client_started_at||Number(data.responses_version)!==payload.expected_version)
        return update('pending','Falta el recibo exacto del inicio. Intención conservada.');
    try {
        if(!await getOfflineStorageDriver().commitVisitaFinalization(claimed,data,isCurrent))
            return update('pending','La copia local cambió al confirmar el inicio. Se reintentará la misma intención.');
    } catch {return update('pending','Inicio confirmado en el servidor; pendiente de conservar su estado local.');}
    if(typeof window!=='undefined')window.dispatchEvent(new CustomEvent('visita-finalization-acknowledged',{detail:{userId:claimed.userId,visitaId:claimed.visitaId}}));
    return {status:'applied',data};
}
